import { ReactNode } from 'react';
import { Box, BoxProps } from '@mui/material';

interface GridProps extends Omit<BoxProps, 'display'> {
  children: ReactNode;
  columns?:
    | number
    | { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };
  gap?: number;
  maxWidth?: number | string;
}

const Grid: React.FC<GridProps> = ({
  children,
  columns = 1,
  gap = 3,
  maxWidth,
  sx,
  ...props
}) => {
  const getGridTemplateColumns = () => {
    if (typeof columns === 'number') {
      return {
        xs: '1fr',
        sm: `repeat(${Math.min(columns, 2)}, 1fr)`,
        md: `repeat(${Math.min(columns, 3)}, 1fr)`,
        lg: `repeat(${columns}, 1fr)`,
      };
    }
    return {
      xs: `repeat(${columns.xs || 1}, 1fr)`,
      sm: `repeat(${columns.sm || columns.xs || 1}, 1fr)`,
      md: `repeat(${columns.md || columns.sm || columns.xs || 1}, 1fr)`,
      lg: `repeat(${columns.lg || columns.md || columns.sm || columns.xs || 1}, 1fr)`,
      xl: `repeat(${columns.xl || columns.lg || columns.md || columns.sm || columns.xs || 1}, 1fr)`,
    };
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: getGridTemplateColumns(),
        gap,
        ...(maxWidth && { maxWidth }),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default Grid;
